"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAction = exports.FormStatus = void 0;
var FormStatus;
(function (FormStatus) {
    FormStatus["INIT"] = "init";
    FormStatus["DIRTY"] = "dirty";
    FormStatus["VALIDATING"] = "validating";
    FormStatus["VALID"] = "valid";
    FormStatus["INVALID"] = "invalid";
    FormStatus["SUBMITTING"] = "submitting";
    FormStatus["SUBMIT_SUCCESS"] = "submit-success";
    FormStatus["SUBMIT_FAILED"] = "submit-failed";
})(FormStatus || (exports.FormStatus = FormStatus = {}));
var FormAction;
(function (FormAction) {
    FormAction["EDIT"] = "edit";
    FormAction["VALIDATE"] = "validate";
    FormAction["SUBMIT"] = "submit";
    FormAction["SUCCESS"] = "success";
    FormAction["FAIL"] = "fail";
})(FormAction || (exports.FormAction = FormAction = {}));
